import Vue from 'vue'
import Vuex from 'vuex'
// standardni volani vuci backendum
import BffAPI from '../service/BffAPI'
import cookie from 'vue-cookies'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		sso: '',
		jwt: '',
		authOtpError: false,
		errorOtp: false,
		errorUsername: false,
		isDataLoaded: false,
		isDataTariffInfoLoaded: false,
		response: null,
		loginSpinner: false,
		eligibilityTariffChange: false,
		eligibilityProlongation: false,
		singleTariffChangeEsid: '',
		tariffChangeSuIds: [],
		tariffData: [],
		selectedTariff: [],
		confirmStatusLoading: true,
		confirmStatusInfo: null,
		linksForEshop: [],
		// DK new properties for migration screen
		isMigrationDataLoaded: false,
		isBasicInfoDataError: false,
		basicInfoData: null,
		transformInfoData: [],
		confirmSimpleStatusInfo: null,
		currentPageOtherTariffs: 14,
		resetMap: false,
		//
		showInputMsisdn: true,
		showInputOtp: false,
		isOtpTab: true,
		showAsIsTariff: true
	},
	mutations: {
		SET_ERROR(state) {
			state.isMigrationDataLoaded = true
			state.isBasicInfoDataError = true
		},
		SET_SSO_TOKEN(state, soo) {
			state.sso = soo
		},
		SET_RESPONSE_DATA(state, data) {
			state.response = data
		},
		SET_JWT_TOKEN(state, token) {
			state.jwt = token
			this.dispatch('GET_BASIC_INFO', token)
			this.dispatch('GET_ALL_ESHOLINKS')
		},
		SET_LOGIN_SPINNER(state) {
			state.loginSpinner = !state.loginSpinner;
		},
		SHOW_INPUT_OTP(state, data) {
			console.log(data)
			state.showInputMsisdn = false
			state.showInputOtp = true
		},
		SET_AUTHENTICATION_OTP_ERROR(state) {
			state.authOtpError = true
		},
		SET_AUTHENTICATION_SEND_OTP_ERROR(state) {
			state.errorOtp = true
		},
		SET_AUTHENTICATION_USERNAME_ERROR(state) {
			state.errorUsername = true
		},
		CLEAR_ERROR(state) {
			state.authOtpError = false
			state.errorOtp = false
			state.errorUsername = false
		},
		SET_STATUS_ABOUT_USER(state, data) {
			state.eligibilityMultiProlongation = data.eligibilityMultiProlongation
			state.eligibilitySingleProlongation = data.eligibilitySingleProlongation
			state.singleProlongationEsid = data.singleProlongationEsid
			state.eligibilitySingleTariffChange = data.eligibilitySingleTariffChange
			state.singleTariffChangeEsid = data.singleTariffChangeEsid
			state.tariffChangeSuIds = data.tariffChangeSuIds
			state.isDataLoaded = true
			state.isDataTariffInfoLoaded = false
		},
		SET_TARIFF_INFO(state, data) {
			state.isDataTariffInfoLoaded = true
			state.tariffData = data.tariffChangeItemDetail
		},
		SET_BASIC_INFO(state, data) {
			state.showAsIsTariff = !data.doNotShowAsIsTariff
			state.basicInfoData = data
			state.transformInfoData = data.eligibilityChecks !== null ? data.eligibilityChecks.map(it => createRecord(it)) : []
			state.isMigrationDataLoaded = true
		},
		SET_SUBSCRIBER_INFO(state, response) {
			const changedRec = state.transformInfoData.filter(it => it.subscriberId === response.subscriberId)
			if (changedRec !== null && changedRec[0] !== null) {
				changedRec[0].dataLoaded = true
				changedRec[0].data = response.data
				changedRec[0].currentTariff = response.data.currentTariffDetail
				changedRec[0].newTariffDetail = response.data.newTariffDetail
			}
		},
		SET_RESULT_INFO(state, data) {
			state.confirmStatusLoading = false
			state.confirmStatusInfo = data != null && data.bulkTariffChangeOrderResItems != null ? data.bulkTariffChangeOrderResItems : null
		},
		SET_RESULT_SIMPLE_INFO(state, data) {
			state.confirmSimpleStatusInfo = data != null && data.bulkTariffChangeOrderResItems != null ? data.bulkTariffChangeOrderResItems : null
		},
		SET_ESHOP_LINK(state, data) {
			const vals = state.linksForEshop.find(e => e.eshopLinkId === data.eshopLinkId);
			if (vals === undefined) {
				state.linksForEshop.push(data)
				this.dispatch('CREATE_LINK_TO_ESHOP', data.eshopLinkId)
			} else {
				vals.linkValue = data.linkValue
			}
		},
		CLEAR_DATA(state) {
				state.jwt = ''
				state.isDataLoaded = false
				state.isDataTariffInfoLoaded = false
				state.response = null
				state.eligibilityTariffChange = false
				state.eligibilityProlongation = false
				state.singleTariffChangeEsid = false
				state.tariffChangeSuIds = []
				state.tariffData = []
				state.selectedTariff = []
				state.confirmStatusLoading = false
				state.confirmStatusInfo = null
				state.isMigrationDataLoaded = false
				state.isBasicInfoDataError = false
				state.basicInfoData = null
				state.transformInfoData = []
				state.confirmSimpleStatusInfo = null
				state.currentPageOtherTariffs = 14
				state.resetMap = false

				state.showInputMsisdn = true
				state.showInputOtp = false
				state.isOtpTab = true
		}
	},
	actions: {
		LOGIN_NEW_USER(context, params) {
			context.commit('CLEAR_ERROR')
			context.commit('SET_LOGIN_SPINNER')
			if (params.type == 'NAME') {
				BffAPI.loginByUsernameAndPassword(params.username, params.password)
				.then(token => {
					context.commit('SET_JWT_TOKEN', token.accessToken)
					cookie.set('ssoId', token.cvalue, 86400, '/', 't-mobile.cz', true, null);
					context.commit('SET_LOGIN_SPINNER')
				}).catch(error => {
					context.commit('SET_AUTHENTICATION_USERNAME_ERROR', error.response.status)
					context.commit('SET_LOGIN_SPINNER')
				});
			} else if (params.type == 'COTP') {
				BffAPI.createOtp(params.serviceId)
				.then(otp => {
					context.commit('SHOW_INPUT_OTP', otp)
					context.commit('SET_LOGIN_SPINNER')
				})
				.catch(error => {
					console.log(error)
					context.commit('SET_AUTHENTICATION_OTP_ERROR')
					context.commit('SET_LOGIN_SPINNER')
				})
			} else {
				BffAPI.loginByOtpAndService(params.otp, params.serviceId)
				.then(token => {
					context.commit('SET_JWT_TOKEN', token.accessToken)
					cookie.set('ssoId', token.cvalue, 86400, '/', 't-mobile.cz', true, null);
					context.commit('SET_LOGIN_SPINNER')
				}).catch(error => {
					console.log(error)
					context.commit('SET_AUTHENTICATION_SEND_OTP_ERROR')
					context.commit('SET_LOGIN_SPINNER')
				})
			}
		},
		CHECK_LOGIN(context, query) {
			const ssoCookie = cookie.get('ssoId')

			if (query.sso === undefined || query.sso.length === 0) {
				if (ssoCookie != undefined && ssoCookie.length > 0) {
					BffAPI.loginByCookie(ssoCookie)
					.then(
							data => {
								context.commit('SET_JWT_TOKEN', data.accessToken)
							}
					)
					return;
				}
				return;
			} else {
				context.commit('SET_SSO_TOKEN', query.sso)
			}
			const dat = {
				'ssoToken': query.sso
			}
			BffAPI.loginUser(dat)
			.then(
					data => {
						context.commit('SET_JWT_TOKEN', data.accessToken)
						cookie.set('ssoId', data.cvalue, 86400, '/', 't-mobile.cz', true, null);

					}
			)
			.catch(
					error => {
						context.commit('SET_AUTHENTICATION_OTP_ERROR', error.response.status)
					}
			)
		},
		GET_BASIC_INFO(context, token) {
			BffAPI.getBasicInfo(token)
			.then(data => {
				context.commit('SET_BASIC_INFO', data)
			})
			.catch(error => {
				context.commit('SET_ERROR', error)
			})
		},

		GET_STATUS_ABOUT_USER(context, params) {
			BffAPI.getStatusAboutUser(params.data)
			.then(data => {
				context.commit('SET_STATUS_ABOUT_USER', data)
			})
			.catch(error => {
				console.log(error)
				context.commit('SET_ERROR', null)
			})
		},
		CLEAR_LOGIN_ERROR(context) {
			context.commit(
					'CLEAR_ERROR'
			)

		},
		CREATE_LINK_TO_ESHOP(context, linkId) {
			if (linkId == undefined || linkId.length == 0) {
				BffAPI.getLinkOnEshopWithoutId(context.state.jwt)
				.then(dat => {
					context.commit('SET_ESHOP_LINK', {eshopLinkId: 'default', linkValue: dat})
				})
			} else {
				BffAPI.getLinkOnEshopWithId(linkId, context.state.jwt)
				.then(dat => {
					context.commit('SET_ESHOP_LINK', {eshopLinkId: linkId, linkValue: dat})
				})
			}
		},
		GET_ALL_ESHOLINKS(context) {
			context.state.linksForEshop.forEach(e => {
				context.dispatch('CREATE_LINK_TO_ESHOP', e.eshopLinkId);
			})

		},
		LOGOUT (context) {
			BffAPI.logout(context.state.jwt, cookie.get('ssoId') )
			context.commit('CLEAR_DATA')
			cookie.remove('ssoId', '/', 't-mobile.cz')
		}

	}
})

function createRecord(record) {

	return {
		alias: record.alias,
		endDate: record.endDate,
		msisdn: formatMsisdn(record.msisdn),
		qualificationResults: record.qualificationResults,
		subscriberId: record.subscriberId,
		dataLoaded: false,
		data: [],
		currentTariff: null,
		newTariffDetail: null
	}
}

function formatMsisdn(value) {

	if (value.includes("DSL") || value.includes("OPT") || value.includes("TV")) {
		return value
	}

	if (value !== undefined && value.startsWith('420')) {
		value = value.replace('420', '+420')
	} else if (value !== undefined && !value.startsWith('420')) {
		value = '+420' + value
	}
	value = value.replace(/(\d{3})(\d{3})(\d{3})(\d{3})/, '$1 $2 $3 $4');
	return value
}